import { useFragment } from "react-relay"
import { UserAvatarTooltip } from "@/components/avatar-user-tooltip"
import { UserProvider } from "@/components/user-wrapper"
import { PatientFileLockFragment$key } from "@/modules/patients/services/__generated__/PatientFileLockFragment.graphql"
import { PatientFragment$data } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { Appointment } from "@/modules/patients/services/PatientAppointment"
import { PatientFileLockFragment } from "@/modules/patients/services/PatientFileLockFragment"
import { AppointmentClosedStatusIndicator } from "@/modules/waiting-room/components/appointment-closed-status-indicator"
import { AppointmentEditStatusIndicator } from "@/modules/waiting-room/components/appointment-edit-status-indicator"

const AgendaStatusCell = ({ appointment, patient }: { appointment: Appointment; patient: PatientFragment$data }) => {
  const { id, status, takenBy, completedAt } = appointment
  const { lockedBy, lockedAt } = useFragment<PatientFileLockFragment$key>(
    PatientFileLockFragment,
    patient.patientFileLock,
  )

  return (
    <div className="flex items-center gap-2">
      {status === "CLOSED" && (
        <>
          <UserProvider
            userName={takenBy}
            render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier={`status-last-updated-by-${id}`} />}
          />
          <AppointmentClosedStatusIndicator completedAt={completedAt} />
        </>
      )}
      {status === "CANCELLED" && (
        <>
          <UserProvider
            userName={takenBy}
            render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier={`status-last-updated-by-${id}`} />}
          />
          <AppointmentClosedStatusIndicator completedAt={completedAt} isCancelled={true} />
        </>
      )}
      {status === "IN_PROGRESS" && lockedBy && (
        <>
          <UserProvider
            userName={lockedBy}
            render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier={`status-last-updated-by-${id}`} />}
          />
          <AppointmentEditStatusIndicator lockedAt={lockedAt} />
        </>
      )}
    </div>
  )
}

export { AgendaStatusCell }
